export interface Storage {
    getItem(key: string): string | null;
    setItem(key: string, value: any): void;
    removeItem(key: string): void;
}

class MemoryStorage implements Storage {
    #storage: Record<string, any> = {};

    getItem(key: string): string | null {
        return this.#storage[key] || null;
    }

    removeItem(key: string): void {
        delete this.#storage[key];
    }

    setItem(key: string, value: any): void {
        this.#storage[key] = value;
    }
}

const storage: Storage = window.localStorage || new MemoryStorage();

export default storage;
